/* eslint-disable max-len */
import { useState } from "react";

import { faCircle, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useCookies } from "react-cookie";

import { ROUTES } from "@/helpers/routes";
import CustomModal from "@/shared/components/CustomModal";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../shared/components/layout";

export default function Cookies() {
    const [cookies, setCookie] = useCookies(["UpdatedUserCookieSettings"]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEsentialChecked, setEsentialCheckBox] = useState(true);
    let IsAnalyticsVal = true;
    let IsAdvVal = true;
    if (cookies && cookies.UpdatedUserCookieSettings && cookies.UpdatedUserCookieSettings.userConfig) {
        IsAnalyticsVal = cookies.UpdatedUserCookieSettings.userConfig.IsAnalyticsChecked;
        IsAdvVal = cookies.UpdatedUserCookieSettings.userConfig.IsAdvChecked;
    }

    const [isAnalyticsChecked, setAnalyticsCheckBox] = useState(IsAnalyticsVal);
    const [isAdvChecked, setAdvCheckBox] = useState(IsAdvVal);
    const toggleCookieModal = () => {
        setUserCookie();
        setIsModalOpen(false);
    };
    const openCookieModal = () => {
        setIsModalOpen(true);
    };

    const setUserCookie = () => {
        const cookieVal = {
            userConfig: {
                IsEsentialChecked: isEsentialChecked,
                IsAnalyticsChecked: isAnalyticsChecked,
                IsAdvChecked: isAdvChecked,
            },
        };

        setCookie("UpdatedUserCookieSettings", cookieVal);

        setGoogleConsent(cookieVal);
    };

    const setGoogleConsent = (UpdatedUserCookieSettings: any) => {
        console.log("UpdatedUserCookieSettings: ", UpdatedUserCookieSettings);
        if (UpdatedUserCookieSettings) {

            if (UpdatedUserCookieSettings.userConfig.IsAnalyticsChecked && UpdatedUserCookieSettings.userConfig.IsAdvChecked) {
                // console.log(`updating consent, ${JSON.stringify(UpdatedUserCookieSettings.userConfig)}`);
                gtag("consent", "update", {
                    "ad_storage": "granted",
                    "analytics_storage": "granted",
                });
            } else if (UpdatedUserCookieSettings.userConfig.IsAnalyticsChecked && !UpdatedUserCookieSettings.userConfig.IsAdvChecked) {
                // console.log(`updating consent, ${JSON.stringify(UpdatedUserCookieSettings.userConfig)}`);
                gtag("consent", "update", {
                    "ad_storage": "denied",
                    "analytics_storage": "granted",
                });
            } else if (!UpdatedUserCookieSettings.userConfig.IsAnalyticsChecked && UpdatedUserCookieSettings.userConfig.IsAdvChecked) {
                // console.log(`updating consent, ${JSON.stringify(UpdatedUserCookieSettings.userConfig)}`);
                gtag("consent", "update", {
                    "ad_storage": "granted",
                    "analytics_storage": "denied",
                });
            } else {
                // console.log(`updating consent, ${JSON.stringify(UpdatedUserCookieSettings?.userConfig)}`);
                gtag("consent", "update", {
                    "ad_storage": "denied",
                    "analytics_storage": "denied",
                });
            }
        } else {
            // console.log("updating consent to default");
            gtag("consent", "default", {
                "ad_storage": "granted",
                "analytics_storage": "granted",
            });
        }

        setIsModalOpen(false);
    };
    const setCheckboxValues = (evt: any, typeId: number) => {
        console.log(evt.currentTarget.checked);
        if (typeId == 1) {
            setEsentialCheckBox(evt.currentTarget.checked);
        } else if (typeId == 2) {
            setAnalyticsCheckBox(evt.currentTarget.checked);
        } else if (typeId == 3) {
            setAdvCheckBox(evt.currentTarget.checked);
        }
        return evt.currentTarget.checked;
    };

    return (
        <div>
            <PageSeo title="Cookies | The Gender Index" pathname={ROUTES.cookies} />
            <Layout>
                <div className='singleLayout privacyPage'>

                    <h3>Cookies and Legals</h3>
                    <div className='tabsNavigation'>
                        <ul className='commonList'>
                            <li >
                                <Link href="/privacy-policy">Privacy Policy</Link>
                            </li>
                            <li className='active'>
                                <Link href="/cookies">Cookies</Link>
                            </li>
                            <li>
                                <Link href="/terms-and-conditions">Terms and Conditions</Link>
                            </li>
                            {/* <li>
                                <Link href="/strategic">Strategic sponsor</Link>
                            </li> */}
                        </ul>
                    </div>
                    <p className='body-default-copy-large'>May 2023</p>
                    <div className='heroBanner'>
                        {/* <img src="/images/cookies.jpg" alt="report_cover_image" /> */}
                        <Image
                            src="/images/cookies.jpg"
                            alt="report_cover_image"
                            width={917}
                            height={368}
                            loading="lazy"
                        />
                    </div>
                    <p className='body-default-copy'>This Cookies Policy explains what Cookies are and how We use them. You should read this policy so You can understand what type of cookies We use, or the information We collect using Cookies and how that information is used.</p>
                    <p className='body-default-copy'><Link href="javascript:void(0)" className="linkText" onClick={openCookieModal}>Change cookie settings here</Link></p>
                    <p className='body-default-copy'>Cookies do not typically contain any information that personally identifies a user, but personal information that we store about You may be linked to the information stored in and obtained from Cookies. For further information on how We use, store and keep your personal data secure, see our Privacy Policy.</p>
                    <p className='body-default-copy'>We do not store sensitive personal information, such as mailing addresses, account passwords, etc. in the Cookies We use.</p>
                    <p className='body-default-copy'>Interpretation and Definitions</p>
                    <p className='body-default-copy'>Interpretation</p>
                    <p className='body-default-copy'>The words of which the initial letter is capitalised have meanings defined under the following conditions.</p>
                    <p className='body-default-copy'>The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
                    <h6>Definitions</h6>
                    <p className='body-default-copy'>For the purposes of this Cookies Policy:</p>
                    <ul className="bulletList">
                        <li>Company (referred to as either “the Company”, “The Gender Index”, “TGI”, “We”, “Us” or “Our” in this Cookies Policy) refers to mnAI Data Solutions Limited, The Beehive, City Place, Gatwick, RH6 0PA.</li>
                        <li>You means the individual accessing or using the Website, or a company, or any legal entity on behalf of which such individual is accessing or using the Website, as applicable.</li>
                        <li>Cookies means small files that are placed on Your computer, mobile device or any other device by a website, containing details of your browsing history on that website among its many uses.</li>
                        <li>Website refers to The Gender Index, accessible from <Link href="https://www.thegenderindex.co.uk" target="_blank" className="linkText">https://www.thegenderindex.co.uk</Link> </li>
                    </ul>
                    <h6>The use of the Cookies</h6>
                    <p className='body-default-copy'>Type of Cookies We Use</p>
                    <p className='body-default-copy'>Cookies can be “Persistent” or “Session” Cookies. Persistent Cookies remain on your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close your web browser.</p>
                    <p className='body-default-copy'>We use both session and persistent Cookies for the purposes set out below:</p>
                    <ul className="bulletList">
                        <li>Necessary / Essential CookiesType: Session CookiesAdministered by: UsPurpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.</li>
                        <li>Functionality CookiesType: Persistent CookiesAdministered by: UsPurpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.</li>
                        <li>Tracking and Performance CookiesType: Persistent CookiesAdministered by: Third-PartiesPurpose: These Cookies are used to track information about traffic to the Website and how users use the Website. The information gathered via these Cookies may directly or indirectly identify you as an individual visitor. This is because the information collected is typically linked to a pseudonymous identifier associated with the device you use to access the Website. We may also use these Cookies to test new advertisements, pages, features or new functionality of the Website to see how our users react to them.</li>
                        <li>Targeting and Advertising CookiesType: Persistent CookiesAdministered by: Third-PartiesPurpose: These Cookies track your browsing habits to enable Us to show advertising which is more likely to be of interest to You. These Cookies use information about your browsing history to group You with other users who have similar interests. Based on that information, and with Our permission, third party advertisers can place Cookies to enable them to show adverts which We think will be relevant to your interests while You are on third party websites.</li>
                    </ul>
                    <h6>Your Choices Regarding Cookies</h6>
                    <p className='body-default-copy'>If You prefer to avoid the use of Cookies on the Website, first You must disable the use of Cookies in your browser and then delete the Cookies saved in your browser associated with this website. You may use this option for preventing the use of Cookies at any time.</p>
                    <p className='body-default-copy'>If You do not accept Our Cookies, You may experience some inconvenience in your use of the Website and some features may not function properly.</p>
                    <p className='body-default-copy'>If You’d like to delete Cookies or instruct your web browser to delete or refuse Cookies, please visit the help pages of your web browser.</p>
                    <ul className="bulletList">
                        <li>For the Chrome web browser, please visit this page from Google: <Link href="https://support.google.com/accounts/answer/32050" target="_blank" className="linkText">Clear cache & cookies - Computer - Google Account Help</Link> </li>
                        <li>For the Internet Explorer web browser, please visit this page from Microsoft: <Link href="https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc" target="_blank" className="linkText">How to delete cookie files in Internet Explorer - Microsoft Support </Link> </li>
                        <li>For the Firefox web browser, please visit this page from Mozilla: <Link href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=en-US" target="_blank" className="linkText">Clear cookies and site data in Firefox | Firefox Help </Link> </li>
                        <li>For the Safari web browser, please visit this page from Apple: <Link href="https://support.apple.com/en-in/guide/safari/sfri11471/mac" target="_blank" className="linkText">Clear cookies in Safari on Mac </Link> </li>
                    </ul>
                </div>
            </Layout>
            <CustomModal
                open={isModalOpen}
                handleClose={toggleCookieModal}
                className={"custom-modal-content"}>
                <div className={"commonModalWrapper"}>
                    <div className="commonModal cookiesModal">
                        <div className="modalHeader">
                            <button className="unstyledButton headerClose" onClick={toggleCookieModal}>
                                <FontAwesomeIcon icon={faClose} />
                            </button>
                        </div>
                        <h5>Your cookie settings</h5>

                        <div className="modalBody">
                            <p className="body-default-copy-medium">Cookies are very small text files that are stored on your computer when you visit some websites.
                                We use cookies to make our website easier for you to use. You can remove any cookies already stored on your computer,
                                but these may prevent you from using parts of our website.</p>
                            <button className="btn-green acceptAllBtn" onClick={toggleCookieModal}>Accept all</button>
                            <div className="cookiesControls">
                                <div className="controlList">
                                    <div className="leftPane">
                                        <FontAwesomeIcon icon={faCircle} />
                                        <div>
                                            <h6>Essential</h6>
                                            <p className="body-default-copy-small">Collect anonymous data about how visitors use our site
                                                and how it performs. We use this to improve our products, services and user experience.</p>
                                        </div>
                                    </div>
                                    {/* <button className="btn-blue" onClick={setActiveValues}>Always active</button> */}
                                    <div className="switchItem">
                                        <label className="switch">
                                            <input type="checkbox" checked={isEsentialChecked} disabled={true} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="controlList">
                                    <div className="leftPane">
                                        <FontAwesomeIcon icon={faCircle} />
                                        <div>
                                            <h6>Analytics</h6>
                                            <p>Analytics cookies allow TGI to analyse your visits and actions on our and third-party apps and websites to understand your interests.</p>
                                        </div>

                                    </div>
                                    <div className="switchItem">
                                        <label className="switch">
                                            <input type="checkbox" checked={isAnalyticsChecked} onClick={(evt: any) => setCheckboxValues(evt, 2)} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="controlList">
                                    <div className="leftPane">
                                        <FontAwesomeIcon icon={faCircle} />
                                        <div>
                                            <h6>Advertising</h6>
                                            <p>Targeted advertising cookies allows TGI to share your data with advertising partners, including social
                                                media companies, to send you more relevant ads.</p>
                                        </div>

                                    </div>
                                    <div className="switchItem">
                                        <label className="switch">
                                            <input type="checkbox" checked={isAdvChecked} onClick={(evt: any) => setCheckboxValues(evt, 3)} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <button className="btn-pink confirmBtn" onClick={toggleCookieModal}>Confirm choices</button>
                        </div>
                    </div>
                </div >
            </CustomModal>
        </div>
    );
}

